export const  SystemConfigs = [
  { name: 'country_code', key: 'DEFAULT_COUNTRY_CODE', default:  "+225"},
  { name: 'site_name', key: 'STR_SITE_NAME', default: "" },
  { name: 'phoneNumberLength', key: 'PHONE_NUMBER_LENGTH', default: 10 },
  { name: 'login_required', key: 'B_LOGIN_REQUIRED', default: 1 },
  { name: 'quick_signup_enabled', key: 'B_ENABLE_QUICK_SIGNUP', default: 0 },
  { name: 'usePromoCode', key: 'USE_PROMO_CODE_REGISTRATION', default: 0 },
  { name: 'useRefAgentCode', key: 'USE_REFERAL_CODE_REGISTRATION', default: 0 },
  { name: 'BL_ALLOW_LOGIN_PHONE_NUMBER', key: 'BL_ALLOW_LOGIN_PHONE_NUMBER', default: 0 },
  // { name: 'STR_MISS_CI_PIN', key: 'STR_MISS_CI_PIN', default: 1357 },
  { name: 'currency', key: 'STR_CURRENCY_CODE', default: 'XOF'},
  { name: 'currencyCode', key: 'STR_DISPLAY_CURRENCY_CODE', default: 'XOF'},
  { name: 'minLegalAge', key: 'MIN_BET_AGE', default: 18},
  { name: 'verifyKYC', key: 'B_VERIFY_KYC', default: 0},
  { name: 'blockDeposit', key: 'B_VERIFY_KYC_ON_DEPOSIT', default: false},
  { name: 'blockWithdrawal', key: 'B_VERIFY_KYC_ON_WITHDRAWAL', default: false},

//   { name: 'send_user_sms_notifications', key: 'SEND_USER_SMS_CONFIRMATIONS', default: false },
//   { name: 'quick_reg_input_fields', key: 'QUICK_SIGNUP_INPUT_FIELDS', default: ['LOGIN', 'PASSWORD'] },
//   { name: 'b_disable_login', key: 'B_DISABLE_LOGIN', default: 0},
//   { name: 'b_disable_account_creation', key: 'B_DISABLE_ACCOUNT_CREATION', default: 0},
//   { name: 'PLAY_STORE_APP_URL', key: 'PLAY_STORE_URL', default: 'market://details?id=com.roblox.client'},
//   { name: 'APP_STORE_APP_URL', key: 'APP_STORE_URL', default: 'https://itunes.apple.com/app/'},
//   { name: 'SWITCH_BTW_SITE_VERSIONS', key: 'SWITCH_BTW_SITE_VERSIONS', default: 0},
//   { name: 'SHOW_NAVIGATION_CARDS', key: 'B_SHOW_NAVIGATION_CARDS', default: 1},
//   { name: 'MIN_WINNERS_AMOUNT', key: 'LATEST_WINNERS_MINIMUM_WINNING_AMOUNT', default: 1},
//   { name: 'MininumLatestWinners', key: 'NUMBER_OF_WINNERS', default: 5},
//   { name: 'showPushMsgs', key: 'B_ENABLE_PUSH_NOTIFICATIONS', default: false},
//   { name: 'checkBalance', key: 'CHECK_ACCOUNT_BALANCE', default: true},
//   { name: 'homePageMarkets', key: 'HOME_PAGE_MARKETS', default: null},
//   { name: 'marketOutcomesSizeForSpecifiers', key: 'MARKET_OUTCOME_SIZE_WITH_SPECIFIERS', default: 2},
//   { name: 'displayMarketOutcomesWithSpecifiersHome', key: 'SHOW_SPECIFIERS_BTW_OUTCOMES', default: false},
//   { name: 'show_Maintenance_Page', key: 'B_SHOW_MAINTAINANCE_PAGE', default: false},
//   { name: 'mapOutcomeIdToDisplayCode', key: 'USE_OUTCOME_ID_AS_DISPLAY', default: false},
//   { name: 'homeEventsGroupSize', key: 'HOME_EVENTS_SIZE_PER_SECTION', default: 5},
//   { name: 'tournamentsEventsGroupSize', key: 'HOME_EVENTS_SIZE_PER_TOURNAMENT', default: 5},
//   { name: 'removeLeadingZeroPhoneNumber', key: 'KEY_REMOVE_LEADING_ZER0', default: 0},
//   { name: 'referalBonusAvailable', key: 'BONUS_PARAINAGE_AVAILABLE', default: 0},
//   { name: 'cookie_session_duration', key: 'S_COOKIE_SESSION_DURATION', default: 24*60*60*1000},
//   { name: 'withdraw_with_incomplete_profile', key: 'B_WITHDRAW_WITH_INCOMPLETE_PROFILE', default: 0},
//   { name: 'withdraw_from_current_account', key: 'B_ALLOW_WITHDRAWAL_FROM_CURRENT_ACCOUNT', default: 0},
//   { name: 'ignoreOptOnWithdrawal', key: 'IGNORE_OTP_ON_WITHDRAWAL', default: 0},
//   { name: 'allow_multiple_payment_account', key: 'B_ENABLE_MULTIPLE_PAYMENT_ACCOUNT', default: 1},
//   { name: 'fullSignupEnabled', key: 'B_ENABLE_FULL_SIGNUP', default: 0 },
]
